/**
 * Quality tier display helpers (M3.3a C2).
 *
 * Maps the 5-tier Quality enum from QUALITY.md to display colors and
 * multipliers. The color scheme follows RPG convention: grey for junk,
 * white for standard, green/blue/purple for ascending rarity.
 */

import type { Quality } from '../wire';

/** CSS color for each quality tier badge. */
export const QUALITY_COLORS: Record<Quality, string> = {
  Poor: '#9d9d9d',       // grey
  Standard: '#ffffff',    // white
  Fine: '#1eff00',        // green
  Superior: '#0070dd',    // blue
  Masterwork: '#a335ee',  // purple
};

/** Server-side multiplier values (QUALITY.md SS2). */
export const QUALITY_MULTIPLIERS: Record<Quality, number> = {
  Poor: 0.7,
  Standard: 1.0,
  Fine: 1.2,
  Superior: 1.4,
  Masterwork: 1.6,
};

/** All quality tiers in ascending order. */
export const QUALITY_TIERS: readonly Quality[] = [
  'Poor',
  'Standard',
  'Fine',
  'Superior',
  'Masterwork',
];
